import React, { createContext, useContext, ReactNode } from 'react';
import { LoadScript } from '@react-google-maps/api';
import { GlobalStyles } from '@mui/material';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const libraries: ("places" | "drawing" | "geometry" | "visualization")[] = ['places'];

const GoogleMapsContext = createContext<boolean>(false);
export const useGoogleMapsLoaded = () => useContext(GoogleMapsContext);

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={libraries}
    >
      <GlobalStyles
        styles={{
          '.pac-container': {
            borderRadius: '8px !important',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15) !important',
            marginTop: '5px !important',
            border: '1px solid #e0e0e0 !important',
            zIndex: 1500,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif !important',
            position: 'absolute !important',
            maxHeight: '200px !important',
          },
          '.pac-item': {
            padding: '10px !important',
            cursor: 'pointer !important',
          },
          '.pac-item:hover': {
            backgroundColor: '#f5f5f5 !important',
          },
          '.pac-item-selected': {
            backgroundColor: '#eee !important',
          },
          '.pac-icon': {
            marginRight: '8px !important',
          },
          '.pac-item-query': {
            fontSize: '14px !important',
            color: '#333 !important',
          },
          '.pac-matched': {
            fontWeight: '600 !important',
          },
          '.pac-secondary-text': {
            fontSize: '12px !important',
            color: '#666 !important',
          },
        }}
      />
      <GoogleMapsContext.Provider value={true}>
        {children}
      </GoogleMapsContext.Provider>
    </LoadScript>
  );
};